<!--病情分级-->
<template>
  <el-button-group
    v-if="!isSmart"
    class="ill-level value"
  >
    <el-button
      type="primary"
      plain
      class="four"
      :disabled="onlyLook"
      :class="{'active-button':active=== '四级'}"
      @click="handleClickLevel('四级')"
    >四级
    </el-button>
    <el-button
      type="primary"
      plain
      class="three"
      :disabled="onlyLook"
      :class="{'active-button':active=== '三级'}"
      @click="handleClickLevel('三级')"
    >三级
    </el-button>
    <el-button
      type="primary"
      plain
      class="two"
      :disabled="onlyLook"
      :class="{'active-button':active=== '二级'}"
      @click="handleClickLevel('二级')"
    >二级
    </el-button>
    <el-button
      type="primary"
      plain
      class="one"
      :disabled="onlyLook"
      :class="{'active-button':active=== '一级'}"
      @click="handleClickLevel('一级')"
    >一级
    </el-button>
  </el-button-group>
  <el-button-group
    v-else
    class="ill-level value"
  >
    <el-button
      type="primary"
      plain
      class="five"
      :disabled="onlyLook"
      :class="{'active-button':active=== '搜救'}"
      @click="handleClickLevel('搜救')"
    >搜救
    </el-button>
    <el-button
      type="primary"
      plain
      class="five"
      :disabled="onlyLook"
      :class="{'active-button':active=== '远程指导'}"
      @click="handleClickLevel('远程指导')"
    >远程指导
    </el-button>
  </el-button-group>
</template>

<script>
export default {
  name: "FourLevel",
  props: {
    isSmart: { // 是否是无人车/机 (只显示2个情况)
      type: Boolean,
      default: false
    },
    level: {
      type: String,
      default: ""
    },
    onlyLook: { // 只能查看不能点击
      type: Boolean,
      default: false,
    }
  },
  emits: ["setNewLevel"],
  data() {
    return {
      active: ""
    };
  },
  watch: {
    level: {
      handler(val) {
        this.active = val;
      },
      immediate: true
    }
  },
  methods: {
    handleClickLevel(val) {
      this.active = val;
      this.$emit("setNewLevel", val);
    }
  }
};
</script>

<style scoped lang="scss">
.ill-level.value {
  .el-button {
    border-radius: 16px;
    height: 32px;
    background-color: transparent;
    width: 88px;
    height: 32px;
    min-height: 32px;
    padding: 0;
  }

  .el-button.five {
    border: 1px solid #75B8E6;
    color: #75B8E6;
  }

  .el-button.four {
    border: 1px solid #75B8E6;
    color: #75B8E6;
  }

  .el-button.three {
    border: 1px solid #79EB86;
    color: #79EB86;
  }

  .el-button.two {
    border: 1px solid #EBAF79;
    color: #EBAF79;
  }

  .el-button.one {
    border: 1px solid #EB7979;
    color: #EB7979;
  }

  .el-button + .el-button {
    margin-left: 24px;
  }

  .el-button:hover,
  .el-button.active-button {
    color: #FBFBFB;
  }

  .el-button.five:hover,
  .el-button.five.active-button {
    background: #75B8E6;
  }

  .el-button.four:hover,
  .el-button.four.active-button {
    background: #75B8E6;
  }

  .el-button.three:hover,
  .el-button.three.active-button {
    background: #79EB86;
  }

  .el-button.two:hover,
  .el-button.two.active-button {
    background: #EBAF79;
  }

  .el-button.one:hover,
  .el-button.one.active-button {
    background: #EC6060;
  }

  .el-button.is-disabled {
    color: #CCCCCC;
    border: 1px solid #CCCCCC;
  }

  .el-button.is-disabled.active-button {
    border: 1px solid #CCCCCC;
    background: #CCCCCC;
    color: #FBFBFB;
  }
}

</style>
